<template>
    <div>
      <div id="preloader">
        <div id="loader" class="dots-fade">
          <div></div>
          <div></div>
          <div></div>
        </div>
      </div>
      <div id="top" class="s-wrap site-wrapper">
        <HeaderComponent />
        <div class="s-content">
          <router-view></router-view>
        </div>
        <FooterComponent />
      </div>
    </div>
  </template>
  
<script>
  import HeaderComponent from '@/components/HeaderComponent.vue';
  import FooterComponent from '@/components/FooterComponent.vue';
  
  export default {
    components: {
      HeaderComponent,
      FooterComponent
    }
  };
</script>
  